/**
 * Geometria do laço em "estádio" (duas retas + dois arcos de raio único, cap. 07): a única curva que o sistema permite.
 * Um nó é posicionado por fração `t` do comprimento do caminho (0 = início, 1 = volta ao início). Portado do modelo do Ângelo.
 */
export function stadiumMetrics(w: number, r: number) {
  const straight = w - 2 * r
  const halfArc = Math.PI * r
  return { straight, halfArc, perimeter: 2 * straight + 2 * halfArc }
}

const round = (n: number) => Math.round(n * 1000) / 1000

export function pointOnStadium(t: number, w: number, h: number, r: number) {
  const { straight, halfArc, perimeter } = stadiumMetrics(w, r)
  let d = (((t % 1) + 1) % 1) * perimeter
  if (d <= straight) return { x: round(r + d), y: 0 }
  d -= straight
  if (d <= halfArc) { const a = -Math.PI / 2 + d / r; return { x: round(w - r + r * Math.cos(a)), y: round(r + r * Math.sin(a)) } }
  d -= halfArc
  if (d <= straight) return { x: round(w - r - d), y: round(h) }
  d -= straight
  const a = Math.PI / 2 + d / r
  return { x: round(r + r * Math.cos(a)), y: round(h - r + r * Math.sin(a)) }
}

export function stadiumPath(w: number, h: number, r: number) {
  return `M ${r} 0 H ${w - r} A ${r} ${r} 0 0 1 ${w - r} ${h} H ${r} A ${r} ${r} 0 0 1 ${r} 0 Z`
}

/** Caixa padrão do laço nos heróis e diagramas (480×340 com 24 de respiro) e suas derivadas. */
export const LOOP_BOX = { viewW: 480, viewH: 340, pad: 24 } as const
export const LOOP_W = LOOP_BOX.viewW - LOOP_BOX.pad * 2
export const LOOP_H = LOOP_BOX.viewH - LOOP_BOX.pad * 2
export const LOOP_R = LOOP_H / 2
/** Posição (%) de um ponto do laço dentro da caixa — para rótulos HTML sobrepostos ao SVG. */
export const loopPosPct = (t: number) => { const { x, y } = pointOnStadium(t, LOOP_W, LOOP_H, LOOP_R); return { left: ((x + LOOP_BOX.pad) / LOOP_BOX.viewW) * 100, top: ((y + LOOP_BOX.pad) / LOOP_BOX.viewH) * 100 } }
